import { render } from "./SubmitPR.vue?vue&type=template&id=257911d9&scoped=true"
import script from "./SubmitPR.vue?vue&type=script&lang=js"
export * from "./SubmitPR.vue?vue&type=script&lang=js"

import "./SubmitPR.vue?vue&type=style&index=0&id=257911d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257911d9"]])

export default __exports__